import { Component, Input, OnInit } from '@angular/core';
import { IAlertaPainelInterface } from '../shared/Util';
import { AlertasCardService } from '../alertas-card/alertas-card.service';
import { NgIf, NgFor } from '@angular/common';
import { AlertaCardNotificacaoComponent } from '../alerta-card-notificacao/alerta-card-notificacao.component';

@Component({
    selector: 'app-alerta-roteiro-notificacao',
    templateUrl: './alerta-roteiro-notificacao.component.html',
    styleUrls: ['./alerta-roteiro-notificacao.component.css'],
    standalone: true,
    imports: [NgIf, NgFor, AlertaCardNotificacaoComponent]
})
export class AlertaRoteiroNotificacaoComponent implements OnInit {

  @Input() dados: any;
  alertas: Array<IAlertaPainelInterface> = []

  constructor(private alertasCardService: AlertasCardService) { }

  ngOnInit(): void {
      this.consultaAlertaPorRoteiro();
  }

  async consultaAlertaPorRoteiro(){
    this.alertas = await this.alertasCardService.getAlertas(this.dados.IdRoteiro);
  }



}
